// UI
import PurchaseOrderCreateEdit from '@/components/purchase_orders/PurchaseOrderCreateEdit'

import ScrollableScreen from '@/components/ui/ScrollableScreen'

// Hook
import usePurchaseOrder from '@/components/purchase_orders/usePurchaseOrder'

export default function IndexPurchaseOrders() {
    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Bons de commande',
            href: '/purchase_orders',
        },
        {
            label: 'Créer un bon de commande',
        },
    ]

    // Hook
    const { purchaseOrder, handlers, isSaving } = usePurchaseOrder()

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs}>
            <PurchaseOrderCreateEdit
                isSaving={isSaving}
                purchaseOrder={purchaseOrder}
                handlers={handlers}
            />
        </ScrollableScreen>
    )
}
